import { render, staticRenderFns } from "./link-document-item-slot.vue?vue&type=template&id=2c93ecee&"
import script from "./link-document-item-slot.vue?vue&type=script&lang=js&"
export * from "./link-document-item-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports